import { render, staticRenderFns } from "./observed_03.vue?vue&type=template&id=57db1ac6&"
import script from "./observed_03.vue?vue&type=script&lang=js&"
export * from "./observed_03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports